import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceZoneRemovalNotificationState = createStateReducer(initialState, {
  [events.removeZoneSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeZone",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.removeZoneFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeZone",
        flags: ["failure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceZoneRemovalNotificationState };
